import { useEffect } from 'react';
import { useLayoutStore } from './layoutStore';
export function PageHeader({ children }) {
    const setPageHeaderContent = useLayoutStore((state)=>state.setPageHeaderContent);
    const clearPageHeaderContent = useLayoutStore((state)=>state.clearPageHeaderContent);
    useEffect(()=>{
        // Set the page header content when component mounts or children change
        setPageHeaderContent(children);
        // Clear the page header content when this component unmounts
        return ()=>{
            clearPageHeaderContent();
        };
    }, [
        children,
        setPageHeaderContent,
        clearPageHeaderContent
    ]);
    // This component doesn't render anything itself
    return null;
}
